import React from 'react'
import { AppBar, Box, Grid, Toolbar, Typography } from '@mui/material'
import { Alerts, ButtonAction, InputButton } from '../../Simple'
import { EmpresasContext } from '../../../contexts/EmpresasContext'
import { CheckoutContext } from '../../../contexts/CheckoutContext'
import { Services } from '../../../services'
import { FaClipboardUser } from 'react-icons/fa6'
import { PiSealPercentFill } from 'react-icons/pi'
import { stMob } from './styles'
import { AgendamentoContext } from '../../../contexts/AgendamentoContext'

export default function ChktBottom({ containRef, observacao }) {
  const { sttPg } = React.useContext(EmpresasContext)
  const { sttCtxChkt, actionsChkt } = React.useContext(CheckoutContext)
  const { sttCtxAgend } = React.useContext(AgendamentoContext)

  const reagendamento = sttCtxAgend.reagendamento

  const pagamentoLocal =
    Object.keys(reagendamento).length > 0
      ? reagendamento.formaPagamento === 'MAQUINA_CARTAO' ||
        reagendamento.formaPagamento === 'LOCAL' ||
        reagendamento.formaPagamento === 'DINHEIRO'
      : false

  async function StartReagendamento() {
    await actionsChkt.ReagendarPedido(reagendamento.idpedido, observacao)
  }

  async function StartAgendamento() {
    if (sttCtxChkt.horaFixaSelecionada !== null) {
      actionsChkt.ConfirmeAgendamentoFixo(observacao)
    } else {
      Object.keys(reagendamento).length === 0
        ? actionsChkt.ConfirmeAgendamentoAvulso(observacao)
        : StartReagendamento()
    }
  }

  function Showregras() {
    return Alerts.swal(
      'warning',
      'Regras de Cancelamento',
      Services.RetornaRegraCancelamentoSwal(sttPg.empresa.regrasCancelamento[0]),
    )
  }

  const [values, setValues] = React.useState({
    porcentagemSinal: sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.porcentagemSinal,
    valorSinal:
      (sttCtxChkt.agendamentoConfirme?.valorTotal *
        sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.porcentagemSinal) /
      100,
    valorSubtotal: sttCtxChkt.agendamentoConfirme?.valorTotal,
  })
  React.useEffect(() => {
    if (sttCtxChkt.cupomAplicado !== null) {
      setValues({
        porcentagemSinal: sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.porcentagemSinal,
        valorSubtotal:
          sttCtxChkt.agendamentoConfirme?.valorTotal - sttCtxChkt.cupomAplicado.valorDesconto,
        valorSinal:
          ((sttCtxChkt.agendamentoConfirme?.valorTotal - sttCtxChkt.cupomAplicado.valorDesconto) *
            sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.porcentagemSinal) /
          100,
      })
    } else {
      setValues({
        porcentagemSinal: sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.porcentagemSinal,
        valorSubtotal: sttCtxChkt.agendamentoConfirme?.valorTotal,
        valorSinal:
          (sttCtxChkt.agendamentoConfirme?.valorTotal *
            sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.porcentagemSinal) /
          100,
      })
    }
  }, [
    sttCtxChkt.cupomAplicado,
    sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.porcentagemSinal,
    sttCtxChkt.agendamentoConfirme?.valorTotal,
  ]) // Incluindo as dependências faltantes

  function VerificaBttConfirmar() {
    if (sttCtxChkt.selTotal || sttCtxChkt.selSinal) {
      if (
        (sttCtxChkt.selCardCredit ||
          sttCtxChkt.selPix ||
          sttCtxChkt.selMaqCredit ||
          sttCtxChkt.selDinheiro) &&
        sttCtxChkt.esporteSelected !== null
      ) {
        return false
      } else {
        return true
      }
    } else {
      return true
    }
  }

  function ReturnTxtButton() {
    if (sttCtxChkt.selTotal || sttCtxChkt.selSinal) {
      if (
        sttCtxChkt.selCardCredit ||
        sttCtxChkt.selPix ||
        sttCtxChkt.selMaqCredit ||
        sttCtxChkt.selDinheiro
      ) {
        if (sttCtxChkt.esporteSelected === null) {
          return 'Selecione um esporte'
        }
        if (sttPg.empresa.solicitaCPF) {
          if (sttCtxChkt.cpfObrigatorio && Object.keys(reagendamento).length > 0)
            return 'Confirmar Reagendamento'
          else if (sttCtxChkt.cpfObrigatorio) return 'Confirmar Agendamento'
          else return 'Adicione o seu CPF'
        } else if (Object.keys(reagendamento).length > 0) return 'Confirmar Reagendamento'
        else {
          return 'Confirmar Agendamento'
        }
      } else {
        return 'Selecione uma forma de pagamento'
      }
    } else {
      return 'Selecione uma forma de pagamento'
    }
  }

  return (
    <AppBar position='fixed' sx={stMob.containAppBottom} ref={containRef}>
      <Toolbar sx={stMob.containToolbar}>
        {sttPg.empresa.solicitaCPF && (
          <ButtonAction
            title={'Adicionar CPF'}
            titleLabel={!sttCtxChkt.cpfObrigatorio ? 'CPF Obrigatório' : ''}
            Icon={FaClipboardUser}
            text={sttCtxChkt.cpfObrigatorio ? 'CPF: ' + sttCtxChkt.cpfObrigatorio : ''}
            confirmed={sttCtxChkt.cpfObrigatorio ? true : false}
            onClick={() => {
              actionsChkt.handleModaisChkt('cpf', true)
            }}
          />
        )}
        {sttCtxChkt.selTotal || sttCtxChkt.selSinal ? (
          <>
            {(sttCtxChkt.selCardCredit ||
              sttCtxChkt.selPix ||
              sttCtxChkt.selMaqCredit ||
              sttCtxChkt.selDinheiro) &&
              Object.keys(reagendamento).length === 0 && (
                <ButtonAction
                  title={'Aplicar Cupom'}
                  titleLabel={
                    sttCtxChkt.cupomAplicado !== null
                      ? `${sttCtxChkt.cupomAplicado.codigo}`
                      : 'Inserir código do cupom de desconto'
                  }
                  Icon={PiSealPercentFill}
                  confirmed={sttCtxChkt.cupomAplicado !== null}
                  onClick={() => {
                    actionsChkt.handleModaisChkt('cupom', true)
                  }}
                />
              )}
            <Grid container spacing={0} padding={'0px 0px 0px 15px'}>
              <Grid item xs={12}>
                <Typography
                  variant='h6'
                  className='label-left'
                  sx={{ width: 'auto', color: 'black', fontWeight: 'bold', fontSize: '16px' }}
                >
                  Resumo dos valores
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography
                  variant='h6'
                  className='text-label-low label-left'
                  sx={{ whiteSpace: 'nowrap' }}
                >
                  {sttCtxChkt.horaFixaSelecionada !== null &&
                  sttCtxChkt.horaFixaSelecionada.tipoMensalista === 'Indeterminado'
                    ? 'Valor por agendamento'
                    : 'Subtotal'}
                </Typography>
              </Grid>
              <Grid item xs={8}>
                {sttCtxChkt.selTotal || sttCtxChkt.selSinal ? (
                  <>
                    {sttCtxChkt.horaFixaSelecionada !== null ? (
                      <Typography variant='h6' className='text-label-low label-right'>
                        {sttCtxChkt.horaFixaSelecionada.tipoMensalista === 'Indeterminado'
                          ? `R$ ${(
                              sttCtxChkt.agendamentoConfirme.valorTotal +
                              sttCtxChkt.agendamentoConfirme.valorDesconto
                            )
                              .toFixed(2)
                              .replace('.', ',')}`
                          : `R$ ${(
                              sttCtxChkt.horaFixaSelecionada.valorTotal +
                              sttCtxChkt.horaFixaSelecionada.descontoGeral
                            )
                              .toFixed(2)
                              .replace('.', ',')}`}
                      </Typography>
                    ) : (
                      <Typography variant='h6' className='text-label-low label-right'>
                        R${' '}
                        {(
                          sttCtxChkt.agendamentoConfirme.valorTotal +
                          sttCtxChkt.agendamentoConfirme.valorDesconto
                        )
                          .toFixed(2)
                          .replace('.', ',')}
                      </Typography>
                    )}
                  </>
                ) : (
                  <Typography variant='h6' className='text-label-low label-right'>
                    - - -
                  </Typography>
                )}
              </Grid>
              {/* Cupom! */}
              {(sttCtxChkt.agendamentoConfirme.valorDesconto > 0 ||
                sttCtxChkt.cupomAplicado ||
                (Object.keys(reagendamento).length > 0 && reagendamento.valorDesconto > 0)) && (
                <>
                  <Grid item xs={4}>
                    <Typography variant='h6' className='text-label-low label-left'>
                      Desconto
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography variant='h6' className='text-label-low label-right'>
                      {sttCtxChkt.horaFixaSelecionada !== null &&
                      sttCtxChkt.horaFixaSelecionada?.tipoMensalista !== 'Indeterminado'
                        ? `R$ ${sttCtxChkt.horaFixaSelecionada.descontoGeral.toFixed(2).toString().replace('.', ',')}`
                        : `R$ ${Number(
                            sttCtxChkt.agendamentoConfirme.valorDesconto +
                              (sttCtxChkt.cupomAplicado?.valorDesconto || 0) +
                              (reagendamento.valorDesconto || 0),
                          )
                            .toFixed(2)
                            .toString()
                            .replace('.', ',')}`}
                    </Typography>
                  </Grid>
                </>
              )}
              {/* Sinal aqui! */}
              {sttCtxChkt.selSinal && (
                <>
                  <Grid item xs={4} display='flex' alignItems='center' padding={'0px !important'}>
                    <Typography
                      variant='h6'
                      className='text-label-low label-left'
                      sx={{ width: 'auto' }}
                    >
                      Valor Sinal
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={8}
                    className='contain-row tw-justify-end'
                    padding={'0px !important'}
                  >
                    <Box display='flex' alignItems='center'>
                      <Typography
                        variant='body2'
                        className='text-label-low label-right text-w-auto text-fs-h5'
                        sx={{ marginRight: '8px', whiteSpace: 'nowrap' }}
                      >
                        {`(${
                          Object.keys(reagendamento).length === 0
                            ? values.porcentagemSinal
                            : (
                                sttCtxChkt.agendamentoConfirme.valorTotal /
                                reagendamento.valorRealizado
                              ).toFixed(2)
                        }% do subtotal)`}
                      </Typography>
                      <Typography
                        variant='h6'
                        className='text-label-low label-right text-w-auto'
                        sx={{ whiteSpace: 'nowrap' }}
                      >
                        {`${
                          Object.keys(reagendamento).length === 0
                            ? Services.FormatValor(values.valorSinal)
                            : Services.FormatValor(reagendamento.valorRealizado)
                        }`}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={4} display='flex' alignItems='center' padding={'0px !important'}>
                    <Typography
                      variant='h6'
                      className='text-label-low label-left'
                      sx={{ width: 'auto' }}
                    >
                      Valor restante
                    </Typography>
                  </Grid>
                  <Grid item xs={8} padding={'0px !important'}>
                    <Box display='flex' alignItems='center' justifyContent='flex-end'>
                      <Typography
                        variant='h6'
                        className='text-label-low label-right'
                        sx={{ whiteSpace: 'nowrap' }}
                      >
                        {`${
                          Object.keys(reagendamento).length === 0
                            ? Services.FormatValor(values.valorSubtotal - values.valorSinal)
                            : Services.FormatValor(
                                values.valorSubtotal - reagendamento.valorRealizado,
                              )
                        }`}
                      </Typography>
                    </Box>
                  </Grid>
                </>
              )}
              {Object.keys(reagendamento).length > 0 && !pagamentoLocal && (
                <>
                  <Grid item xs={4}>
                    <Typography variant='h6' className='text-label-low label-left'>
                      Valor pago anteriormente
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography variant='h6' className='text-label-low label-right'>
                      {`R$ ${reagendamento.valorRealizado.toFixed(2).toString().replace('.', ',')}`}
                    </Typography>
                  </Grid>
                </>
              )}

              {((Object.keys(reagendamento).length > 0 && pagamentoLocal) ||
                Object.keys(reagendamento).length === 0) && (
                <>
                  <Grid item xs={4}>
                    <Typography
                      variant='h6'
                      color={'black'}
                      className='text-label-low label-left'
                      sx={{
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {sttCtxChkt.horaFixaSelecionada !== null &&
                      sttCtxChkt.horaFixaSelecionada.tipoMensalista === 'Indeterminado'
                        ? 'Você irá pagar por agendamento'
                        : 'Você irá pagar'}
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    {sttCtxChkt.selTotal || sttCtxChkt.selSinal ? (
                      <>
                        {sttCtxChkt.horaFixaSelecionada !== null ? (
                          <Typography
                            variant='h6'
                            color={'black'}
                            className='text-label-low label-right'
                          >
                            {sttCtxChkt.horaFixaSelecionada.tipoMensalista === 'Indeterminado'
                              ? `R$ ${sttCtxChkt.horaFixaSelecionada.prePedidos[0].valor.toFixed(2).toString().replace('.', ',')}`
                              : sttCtxChkt.cupomAplicado
                                ? `R$ ${(
                                    sttCtxChkt.horaFixaSelecionada.valorTotal -
                                    sttCtxChkt.cupomAplicado.valorDesconto
                                  )
                                    .toFixed(2)
                                    .toString()
                                    .replace('.', ',')}`
                                : `R$ ${sttCtxChkt.horaFixaSelecionada.valorTotal.toFixed(2).toString().replace('.', ',')}`}
                          </Typography>
                        ) : (
                          <Typography
                            variant='h6'
                            color={'black'}
                            className='text-label-low label-right'
                          >
                            {sttCtxChkt.diaria
                              ? `R$ ${sttCtxChkt.diaria.valorTotal.toFixed(2).toString().replace('.', ',')}`
                              : sttCtxChkt.selTotal
                                ? Object.keys(reagendamento).length > 0 && !pagamentoLocal
                                  ? `R$ ${(values.valorSubtotal - reagendamento.valorTotal).toFixed(2).toString().replace('.', ',')}`
                                  : `R$ ${(values.valorSubtotal - (reagendamento?.valorDesconto || sttCtxAgend.cupomAplicado?.valorDesconto || 0)).toFixed(2).toString().replace('.', ',')}`
                                : `R$ ${values.valorSinal.toFixed(2).toString().replace('.', ',')}`}
                          </Typography>
                        )}
                      </>
                    ) : (
                      <Typography
                        variant='h6'
                        color={'black'}
                        className='text-label-low label-right'
                      >
                        - - -
                      </Typography>
                    )}
                  </Grid>
                </>
              )}
            </Grid>
            <div className='line-divisor' />
          </>
        ) : (
          <></>
        )}
        <Typography
          variant='body2'
          marginBottom={'5px'}
          marginTop={sttCtxChkt.selTotal || sttCtxChkt.selSinal ? '5px' : '10px'}
          className='text-label-low text-center'
        >
          Ao confirmar o agendamento, você concorda com as
          <button className='text-click-hig' onClick={() => Showregras()}>
            {' '}
            regras de cancelamento
          </button>{' '}
        </Typography>
        <InputButton
          variant='contained'
          color='primary'
          disabled={VerificaBttConfirmar()}
          width={'100%'}
          style={{ margin: '0px 0px 15px 0px' }}
          onClick={() => {
            if (sttPg.empresa.solicitaCPF && !sttCtxChkt.cpfObrigatorio) {
              actionsChkt.handleModaisChkt('cpf', true)
            } else {
              StartAgendamento()
            }
          }}
        >
          {ReturnTxtButton()}
        </InputButton>
      </Toolbar>
    </AppBar>
  )
}
